import React, { useContext, useEffect, useState } from 'react';
import ls from 'local-storage';
import {
  CButton,
  CCard,
  CHeader,
  CModal,
  CModalBody,
  CModalFooter,
  CModalHeader,
  CModalTitle,
  CRow,
  CCol,
  CCardHeader,
  CCardBody
} from '@coreui/react';
import Moment from 'moment';
import { useNavigate } from 'react-router-dom';
import { getAll, getRefundSummary } from 'src/services/Refunds';
import { DataGrid } from '@mui/x-data-grid';
import { isWeekend } from 'date-fns';
import { useWindowDimensions } from 'src/reusables/useWindowDimension';
import { AUTH_KEY } from 'src/utils/auth/Authentication';
import { AuthContext } from 'src/App';
import { DateRangePicker } from 'react-date-range';
import BoothPicker from 'src/components/BoothPicker';
import DownloadExcel from 'src/reusables/DownloadExcel';
import formatter from 'src/reusables/formatter';
function Refunds() {
  const [drModal, setDrModal] = useState(false);
  const [refetch, setRefetch] = useState(false);
  const [tableLoading, setTableLoading] = useState(true);
  const endDay = Moment(new Date()).format('YYYY-MM-DD');
  const max = new Date(endDay);

  const [dateRange, setDateRange] = useState([
    {
      startDate: new Date(`${Moment(new Date()).startOf('month')}`),
      endDate: new Date()
    }
  ]);
  const navigate = useNavigate();
  const Auth = useContext(AuthContext);
  const { height, width, comparison } = useWindowDimensions();
  const [refundList, setRefundList] = useState([]);
  const [renderCounter, setRenderCounter] = useState(0);
  const [loading, setLoading] = useState(true);
  const [refundRows, setRefundRows] = useState([]);

  // `SELECT r.id, r.merchant_id, m.name AS merchantName, r.booth_id, r.created_by, u.name AS employeeName, r.transaction_date, r.refund_date, r.amount, r.notes, r.created_at FROM refunds r LEFT JOIN merchants m ON m.id=r.merchant_id LEFT JOIN users u ON u.id=r.created_by WHERE r.deleted_at IS NULL`;
  const refundColumns = [
    { field: 'no', headerName: 'No', width: '10' },
    { field: 'merchantName', headerName: 'Merchant Name', width: '150' },
    { field: 'amount', headerName: 'Amount', width: '100' },
    { field: 'notes', headerName: 'Notes', width: '200' },
    { field: 'employeeName', headerName: 'Created By', width: '100' },
    { field: 'transactionDate', headerName: 'Transaction Date', width: '175' },
    { field: 'refundDate', headerName: 'Refund Date', width: '175' },
    { field: 'createdAt', headerName: 'Created At', width: '175' }
  ];

  async function fetchRefunds(dateFrom, dateTo, id) {
    const data = await getAll(dateFrom, dateTo, id ?? '');
    console.log(data);
    const rows = data.data.map((item, i) => {
      return {
        no: i + 1,
        id: item.id,
        merchantName: item.merchantName,
        merchantID: item.merchant_id,
        boothID: item.booth_id,
        createdBy: item.created_by,
        employeeName: item.employeeName,
        rawTransactionDate: item.transaction_date.substring(0, 10),
        rawRefundDate: item.refund_date.substring(0, 10),
        rawAmount: item.amount,
        transactionDate: formatter('dateOnly', item?.transaction_date ?? '0000-00-00 00:00:00'),
        refundDate: formatter('dateOnly', item?.refund_date ?? '0000-00-00 00:00:00'),
        amount: formatter('currency', item?.amount ?? 0),
        notes: item.notes,
        createdAt: formatter('completeDate', item?.created_at ?? '0000-00-00 00:00:00')
      };
    });

    setRefundRows(rows);

    setRefundList(data.data);
  }

  useEffect(() => {
    setTableLoading(true);
    const newStartDay = formatter('SQLDate', dateRange[0].startDate);
    const newEndDay = formatter('SQLDate', dateRange[0].endDate);
    // if((refetch && renderCounter > 0) || renderCounter === 0){
    fetchRefunds(newStartDay, newEndDay, ls.get('booth')?.id ?? '');
    setRefetch(false);
    // } else {
    // }

    setRenderCounter(renderCounter + 1);
  }, [dateRange, refetch, drModal]);

  function handleRowClick(params) {
    navigate('/refund-actions', { state: { item: params.row } });
  }
  function customDayContent(day) {
    let extraDot = null;
    if (isWeekend(day)) {
      extraDot = (
        <div
          style={{
            height: '5px',
            width: '5px',
            borderRadius: '100%',
            background: 'orange',
            position: 'absolute',
            top: 2,
            right: 2
          }}
        />
      );
    }
  }
  return (
    <div style={{ color: 'black' }}>
      <CRow>
        <CCol>
          <CButton
            className="ml-3 mb-3 btn btn-dark"
            style={{ backgroundColor: '#4E5B97', border: 'none' }}
            hover="true"
            onClick={() => {
              setDrModal(!drModal);
            }}
          >
            <div>
              {Moment(dateRange[0].startDate).format('ll')}
              {' - '}
              {Moment(dateRange[0].endDate).format('ll')}
            </div>
          </CButton>
        </CCol>
        <CCol>
          <BoothPicker />
        </CCol>
      </CRow>

      <CModal
        visible={drModal}
        style={{
          width: comparison < 1 ? '' : 'fit-content',
          overflowX: comparison < 1 ? 'scroll' : 'visible'
        }}
      >
        <CModalHeader
          style={{
            width: comparison < 1 ? `${(85 * 1) / comparison}vw` : ''
          }}
        >
          <CModalTitle>Date Range</CModalTitle>
        </CModalHeader>
        <CModalBody>
          <CCol xs="12" lg="10">
            <DateRangePicker
              onChange={(item) => {
                setDateRange([item.range1]);
                ls.set('dateRange', item.range1);
              }}
              showSelectionPreview={true}
              moveRangeOnFirstSelection={false}
              months={1}
              maxDate={max}
              ranges={dateRange}
              direction="vertical"
              weekStartsOn={1}
              calendarFocus="backwards"
              preventSnapRefocus={true}
              rangeColors={['#4E5B97']}
              dayContentRenderer={customDayContent}
            />
          </CCol>
        </CModalBody>
        <CModalFooter
          style={{
            width: comparison < 1 ? `${(85 * 1) / comparison}vw` : ''
          }}
        >
          <CButton style={{ backgroundColor: '#4E5B97', border: 'none' }} onClick={() => setDrModal(!drModal)}>
            Close
          </CButton>
          <CButton
            style={{ backgroundColor: '#4E5B97', border: 'none' }}
            onClick={() => {
              setRefetch(true);
              setDrModal(false);
            }}
          >
            OK
          </CButton>
        </CModalFooter>
      </CModal>

      <RefundSummary
        dateFrom={dateRange[0].startDate}
        dateTo={dateRange[0].endDate}
        boothId={ls.get('booth')?.id ?? ''}
      />

      <CHeader style={{ fontSize: '30px', marginTop: '3vh', padding: '1vh 2vw 1vh 2vw' }}>
        <CCol xs="8">Refund List: </CCol>
        <CCol xs="4" style={{ display: 'flex', justifyContent: 'flex-end' }}>
          {Auth.isAllowed(Auth.role[AUTH_KEY.export_reports]) && (
            <DownloadExcel
              rows={refundRows}
              columns={refundColumns}
              dateFrom={formatter('SQLDate', dateRange[0].startDate)}
              dateTo={formatter('SQLDate', dateRange[0].endDate)}
              excelName="Refund Report"
              config={{ width: '20' }}
            />
          )}
          {''}
          {Auth.isAllowed(Auth.role[AUTH_KEY.refund_actions]) && (
            <CButton onClick={() => navigate('/refund-actions')} style={{ backgroundColor: '#4E5B97', border: 'none' }}>
              Add Refunds
            </CButton>
          )}
        </CCol>
      </CHeader>
      <CCard style={{ textAlign: 'center' }}>
        <CCardBody>
          <DataGrid
            rows={refundRows}
            columns={refundColumns}
            onRowClick={handleRowClick}
            initialState={{
              pagination: {
                paginationModel: { page: 0, pageSize: 10 }
              }
            }}
            pageSizeOptions={[5, 10, 20, 25]}
            style={{ textAlign: 'center' }}
          />
        </CCardBody>
      </CCard>
    </div>
  );
}
function RefundSummary({ dateFrom, dateTo, boothId }) {
  const [summary, setSummary] = useState({});
  const [refundCount, setRefundCount] = useState(0);
  const [refundAmount, setRefundAmount] = useState(0);
  const [voucherContribution, setVoucherContribution] = useState(0);

  function fetchSummary(dateFrom, dateTo, boothId) {
    getRefundSummary(dateFrom, dateTo, boothId).then((response) => {
      setRefundCount(response.data.refundCount);
      setRefundAmount(response.data.refundAmount);
      setVoucherContribution(response.data.contribution);
      setSummary(response.data);
    });
  }

  useEffect(() => {
    fetchSummary(Moment(dateFrom).format('YYYY-MM-DD'), Moment(dateTo).format('YYYY-MM-DD'), boothId);
  }, [dateFrom, dateTo]);

  return (
    <CCard>
      <CCardHeader>{`Summary for Applied Filter`}</CCardHeader>
      <CCardBody>
        <CRow>
          <CCol md={3} xs={12}>
            <h5>{`Refund Count: ${refundCount}`}</h5>
          </CCol>
          <CCol md={5} xs={12}>
            <h5>{`Refund Amount: ${formatter('currency', -refundAmount)}`}</h5>
          </CCol>
          <CCol md={4} xs={12}>
            <h5>{`Most Refund: ${summary.mostRefundMerchant} (${formatter(
              'currency',
              -summary.mostRefundAmount
            )})`}</h5>
          </CCol>
        </CRow>
      </CCardBody>
    </CCard>
  );
}
export default Refunds;
